import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import { FlowModeEnum } from '@/enum/flow_mode';
import { ExitDialogTypeEnum } from '@/enum/exit_dialog_type';

Vue.use(Vuex);

export default function(
  initialTraits: Record<string, number>,
  flowMode: FlowModeEnum,
  categoryIndex: number,
  initialSectionId: number | null,
  centerActiveCategoryIcon: boolean,
  assetOverrides: string[],
  is3dMode: boolean = false,
  forceShowExitDialog: boolean,
  exitDialogType: ExitDialogTypeEnum,
) {
  return new Vuex.Store({
    state: state(
      initialTraits,
      flowMode,
      categoryIndex,
      initialSectionId,
      centerActiveCategoryIcon,
      assetOverrides,
      is3dMode,
      forceShowExitDialog,
      exitDialogType,
    ),
    getters: getters,
    mutations: mutations,
    actions: actions,
  });
}
